import { Map, fromJS } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { FEATURE_FLAGS_KEY, RESET_STORE } from 'constants/index'

// constants
export const FETCH_FEATURE_FLAGS_TABLE = `${FEATURE_FLAGS_KEY}/FETCH_FEATURE_FLAGS_TABLE`
export const SUCCESS_FEATURE_FLAGS_TABLE = `${FEATURE_FLAGS_KEY}/SUCCESS_FEATURE_FLAGS_TABLE`
export const FAILURE_FEATURE_FLAGS_TABLE = `${FEATURE_FLAGS_KEY}/FAILURE_FEATURE_FLAGS_TABLE`
export const LOAD_FEATURE_FLAGS_TABLE = `${FEATURE_FLAGS_KEY}/LOAD_FEATURE_FLAGS_TABLE`

export const FETCH_FEATURE_FLAGS_FORM = `${FEATURE_FLAGS_KEY}/FETCH_FEATURE_FLAGS_FORM`
export const SUCCESS_FEATURE_FLAGS_FORM = `${FEATURE_FLAGS_KEY}/SUCCESS_FEATURE_FLAGS_FORM`
export const FAILURE_FEATURE_FLAGS_FORM = `${FEATURE_FLAGS_KEY}/FAILURE_FEATURE_FLAGS_FORM`
export const LOAD_FEATURE_FLAGS_FORM = `${FEATURE_FLAGS_KEY}/LOAD_FEATURE_FLAGS_FORM`

export const SET_FEATURE_FLAGS_INFO = `${FEATURE_FLAGS_KEY}/SET_FEATURE_FLAGS_INFO`

export const CLEAR_FEATURE_FLAGS_TABLE = `${FEATURE_FLAGS_KEY}/CLEAR_FEATURE_FLAGS_TABLE`
export const CLEAR_FEATURE_FLAGS_FORM = `${FEATURE_FLAGS_KEY}/CLEAR_FEATURE_FLAGS_FORM`

// actions
export const fetchFeatureFlagsTable = ActionHelper.createActionObj(
  FETCH_FEATURE_FLAGS_TABLE,
)
export const fetchFeatureFlagsForm = ActionHelper.createActionObj(
  FETCH_FEATURE_FLAGS_FORM,
)
export const setFeatureFlagsInfo = ActionHelper.createActionObj(
  SET_FEATURE_FLAGS_INFO,
)
export const clearFeatureFlagsTable = ActionHelper.createActionObj(
  CLEAR_FEATURE_FLAGS_TABLE,
)
export const clearFeatureFlagsForm = ActionHelper.createActionObj(
  CLEAR_FEATURE_FLAGS_FORM,
)

// state
const initialState = () =>
  fromJS({
    isLoadTable: false,
    isLoadForm: false,
    tableData: {
      data: [],
    },
    formData: {
      id: null,
      title: '',
      key: '',
      description: '',
      enabled: false,
      licensees: [],
    },
  })

// reducers
const featureFlags = handleActions(
  {
    [SUCCESS_FEATURE_FLAGS_TABLE]: (state, action) =>
      state.set(
        'tableData',
        Map({
          data: action.payload,
        }),
      ),
    [(combineActions(
      FAILURE_FEATURE_FLAGS_TABLE,
      CLEAR_FEATURE_FLAGS_TABLE,
    ) as unknown) as string]: state =>
      state.set(
        'tableData',
        Map({
          data: [],
        }),
      ),
    [LOAD_FEATURE_FLAGS_TABLE]: (state, action) =>
      state.set('isLoadTable', Boolean(action.payload)),
    [SUCCESS_FEATURE_FLAGS_FORM]: (state, action) =>
      state.set('formData', Map(action.payload)),
    [(combineActions(
      FAILURE_FEATURE_FLAGS_FORM,
      CLEAR_FEATURE_FLAGS_FORM,
    ) as unknown) as string]: state =>
      state.set(
        'formData',
        Map({
          id: null,
          title: '',
          key: '',
          description: '',
          enabled: false,
          licensees: [],
        }),
      ),
    [LOAD_FEATURE_FLAGS_FORM]: (state, action) =>
      state.set('isLoadForm', Boolean(action.payload)),
    [RESET_STORE]: () => initialState,
  },
  initialState(),
)

export default featureFlags
